export default function registerPainting($, apower) {
  $.registerDir("painting", {
    selector: ".painting",
    ref: {
      fitEl: "[data-fit]",
    },
    init: function () {
      var fitDir = this.fitEl.dir("fit");
      fitDir ? fitDir.on("fit", this.adjust, this) : this.adjust(),
        $(window).$on("resize", this.adjust, this);
    },
    adjust: function () {
      768 < window.innerWidth &&
        this.el.each(
          function (index, el) {
            var paintingDiv = $(el);
            this.adjustEachPainting(paintingDiv);
          }.bind(this)
        );
    },
    cancelLastAdjust: function (paintingDiv, writingDiv) {
      paintingDiv.css("margin-top", ""), writingDiv.css("margin-top", "");
    },
    adjustEachPainting: function (paintingDiv) {
      var writingMarginTop,
        paintingMarginTop,
        paintingMarginBottom,
        writingHeight,
        paintingCenter,
        writingCenter,
        margin,
        wrapperDiv = paintingDiv.closest(".wrapper"),
        writingDiv = paintingDiv.siblings(".writing");
      (wrapperDiv.length && wrapperDiv.css("display").includes("flex")) ||
        !writingDiv[0] ||
        (this.cancelLastAdjust(paintingDiv, writingDiv),
        (writingMarginTop =
          writingDiv.cssNum("margin-top") +
          writingDiv.find("h2").cssNum("margin-top")),
        (paintingMarginTop = paintingDiv.cssNum("margin-top")),
        (paintingMarginBottom = paintingDiv.cssNum("margin-bottom")),
        (writingHeight =
          writingDiv[0].offsetHeight -
          writingDiv.find("h2").cssNum("margin-top")),
        paintingMarginBottom < 0
          ? ((margin = wrapperDiv.innerHeight() / 2 - writingHeight / 2),
            writingDiv.is("[data-skip-align]") ||
              writingDiv.css("margin-top", margin))
          : ((paintingCenter =
              paintingMarginTop + paintingDiv[0].offsetHeight / 2),
            (writingCenter = writingMarginTop + writingHeight / 2),
            20 < Math.abs(paintingCenter - writingCenter) &&
              (writingCenter < paintingCenter
                ? ((margin =
                    writingDiv.cssNum("margin-top") +
                    paintingCenter -
                    writingCenter),
                  writingDiv.is("[data-skip-align]") ||
                    writingDiv.css("margin-top", margin))
                : ((margin =
                    paintingDiv.cssNum("margin-top") +
                    writingCenter -
                    paintingCenter),
                  paintingDiv.is("[data-skip-align]") ||
                    paintingDiv.css("margin-top", margin)))));
    },
  });
}
